import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { AccessibleTreeView } from '@bingads-webui-react/accessible-tree-view';
import { NodeProps } from '@bingads-webui-react/tree-view';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getPageMenuStyles } from '../styles/page-menu-styles';

class PageMenu extends React.PureComponent {
  componentDidUpdate() {
    if (this.props.perfMarker &&
      !this.props.perfMarker.isDone
    ) {
      this.props.perfMarker.done();
    }
  }

  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        <AccessibleTreeView
          ariaLabel={this.props.ariaLabel}
          nodes={this.props.treeNodes}
          treeViewClassNames={classNames(classes.treeViewContainer, 'main-menu-tree')}
          nodeChildRenderer={this.props.nodeChildRenderer(classes)}
          nodePaddingLeft={0}
          onChange={() => {}}
        />
      </React.Fragment>
    );
  }
}

PageMenu.propTypes = {
  classes: PropTypes.shape(_.mapObject(
    getPageMenuStyles({}, {}),
    _.constant(PropTypes.string.isRequired)
  )).isRequired,
  treeNodes: PropTypes.arrayOf(NodeProps).isRequired,
  nodeChildRenderer: PropTypes.func.isRequired,
  perfMarker: PropTypes.shape({
    done: PropTypes.func.isRequired,
    isDone: PropTypes.bool.isRequired,
  }),
  ariaLabel: PropTypes.string,
};

PageMenu.defaultProps = {
  perfMarker: null,
  ariaLabel: '',
};

export default withDefaultStyles(PageMenu, getPageMenuStyles);
